import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const RangeSlider = ({min, max, price, setPrice }) => {
  return (
     <div style={{ padding: '20px 0' }}>
      <Slider
        range
        min={min}
        max={max}
        step={10}
        value={price}
        onChange={(values) => setPrice(values)}
        styles={{
          track: {
            backgroundColor: "#3b82f6",
            height: 4,
          },
          tracks: {
            backgroundColor: "#3b82f6",
            height: 4,
          },
          handle: {
            borderColor: "#3b82f6",
            borderWidth: 3,
            height: 16,
            width: 16,
            backgroundColor: "#fff",
            opacity: 1,
            marginTop: -6,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          },
          rail: {
            backgroundColor: "#d1d5db",
            height: 4,
          },
        }}
      />
    </div>
  );
};

export default RangeSlider;